import React from "react";
import { Flex, Box } from "grid-styled";
import _ from "lodash";

import { Avatar, Relative, Badge } from "../globals";

const DesignersPreview = ({ designers }) => {
    designers = _.orderBy(
        designers,
        [designer => designer.firstName, designer => designer.lastName],
        ["asc", "asc"]
    );

    /*
    designers = [
        {
            avatar:
                "https://pbs.twimg.com/profile_images/839990374475087872/A2n3k2Qd_400x400.jpg",
            firstName: "Kat",
            id: "6",
            lastName: "Fukui",
            title: "Product designer at GitHub",
            twitterUsername: "katfukui",
            websiteLink: "http://katfukui.com/"
        },
        {
            avatar:
                "https://pbs.twimg.com/profile_images/570313913648955392/cf4tgX7M_400x400.jpeg",
            firstName: "Brian",
            id: "7",
            lastName: "Lovin",
            title: "Co-founder of Spectrum",
            twitterUsername: "brian_lovin",
            websiteLink: "https://brianlovin.com/"
        },
        {
            avatar:
                "https://pbs.twimg.com/profile_images/839990374475087872/A2n3k2Qd_400x400.jpg",
            firstName: "Kat",
            id: "6",
            lastName: "Fukui",
            title: "Product designer at GitHub",
            twitterUsername: "katfukui",
            websiteLink: "http://katfukui.com/"
        },
        {
            avatar:
                "https://pbs.twimg.com/profile_images/570313913648955392/cf4tgX7M_400x400.jpeg",
            firstName: "Brian",
            id: "7",
            lastName: "Lovin",
            title: "Co-founder of Spectrum",
            twitterUsername: "brian_lovin",
            websiteLink: "https://brianlovin.com/"
        },
        {
            avatar:
                "https://pbs.twimg.com/profile_images/839990374475087872/A2n3k2Qd_400x400.jpg",
            firstName: "Kat",
            id: "6",
            lastName: "Fukui",
            title: "Product designer at GitHub",
            twitterUsername: "katfukui",
            websiteLink: "http://katfukui.com/"
        },
        {
            avatar:
                "https://pbs.twimg.com/profile_images/570313913648955392/cf4tgX7M_400x400.jpeg",
            firstName: "Brian",
            id: "7",
            lastName: "Lovin",
            title: "Co-founder of Spectrum",
            twitterUsername: "brian_lovin",
            websiteLink: "https://brianlovin.com/"
        },
        {
            avatar:
                "https://pbs.twimg.com/profile_images/839990374475087872/A2n3k2Qd_400x400.jpg",
            firstName: "Kat",
            id: "6",
            lastName: "Fukui",
            title: "Product designer at GitHub",
            twitterUsername: "katfukui",
            websiteLink: "http://katfukui.com/"
        },
        {
            avatar:
                "https://pbs.twimg.com/profile_images/570313913648955392/cf4tgX7M_400x400.jpeg",
            firstName: "Brian",
            id: "7",
            lastName: "Lovin",
            title: "Co-founder of Spectrum",
            twitterUsername: "brian_lovin",
            websiteLink: "https://brianlovin.com/"
        },
        {
            avatar:
                "https://pbs.twimg.com/profile_images/839990374475087872/A2n3k2Qd_400x400.jpg",
            firstName: "Kat",
            id: "6",
            lastName: "Fukui",
            title: "Product designer at GitHub",
            twitterUsername: "katfukui",
            websiteLink: "http://katfukui.com/"
        },
        {
            avatar:
                "https://pbs.twimg.com/profile_images/570313913648955392/cf4tgX7M_400x400.jpeg",
            firstName: "Brian",
            id: "7",
            lastName: "Lovin",
            title: "Co-founder of Spectrum",
            twitterUsername: "brian_lovin",
            websiteLink: "https://brianlovin.com/"
        },
        {
            avatar:
                "https://pbs.twimg.com/profile_images/839990374475087872/A2n3k2Qd_400x400.jpg",
            firstName: "Kat",
            id: "6",
            lastName: "Fukui",
            title: "Product designer at GitHub",
            twitterUsername: "katfukui",
            websiteLink: "http://katfukui.com/"
        },
        {
            avatar:
                "https://pbs.twimg.com/profile_images/570313913648955392/cf4tgX7M_400x400.jpeg",
            firstName: "Brian",
            id: "7",
            lastName: "Lovin",
            title: "Co-founder of Spectrum",
            twitterUsername: "brian_lovin",
            websiteLink: "https://brianlovin.com/"
        }
    ];
    */

    const avatars = [];

    for (let i = 0; i < designers.length; i++) {
        const designer = designers[i];

        if (i !== 6) {
            avatars.push(
                <Relative left={-2 - i * 8} key={designer.id}>
                    <Avatar
                        key={designer.id}
                        src={designer.avatar}
                        alt={`${designer.firstName} ${designer.lastName}`}
                        size={28}
                        border="2px solid white"
                    />
                </Relative>
            );
        } else {
            avatars.push(
                <Relative left={2 - 8 * (i - 1)} key={designer.id}>
                    <Box>
                        <Badge
                            border="2px solid white"
                            size={28}
                            px={1}
                        >{`+${designers.length - i}`}</Badge>
                    </Box>
                </Relative>
            );
            break;
        }
    }

    return (
        <Flex
            aria-label={`Recommended ${designers.length} ${
                designers.length === 1 ? "time" : "times"
            }`}
        >
            {avatars}
        </Flex>
    );
};

export default DesignersPreview;



// WEBPACK FOOTER //
// ./src/components/DesignersPreview/index.js